import { EmptyMessageCustomization } from "@multiweb/frames";
import { ICustomElement } from "../../../UI.BaseControls/ICustomElement";

/**
* Element s informacemi, který se zobrazuje v situaci, kdy Datagrid nemá žádne záznamy, které by zobrazil
*/
export interface IEmptyDataGridMessage extends HTMLElement, ICustomElement {
    /**
     * Typ zprávy, podle které se může řídit zobrazený obsah
     */
    messageType: EmptyDatagridMessageType;

    /**
     * Vyhledávaný text ve fulltextovém vyhledávání
     */
     fulltextSearchString: string;

    /**
     * Nastaví element do režimu QueryMode, kdy se zobrazuje zpráva a tlačítko, umožňující načtení všech dat
     * @param dataLoad Funkce, spuštěná po kliku na tlačítko
     */
    setTypeToQueryMode(dataLoad: Function): void;

    /**
     * Umožňuje nastavit vlastní hlášky a ikony.
     */
    emptyMessageCustomization: EmptyMessageCustomization;
}

export enum EmptyDatagridMessageType {
    /** Datagrid je prázdný před prvním načtením dat */
    initialEmpty,
    /** Datagrid je prázdný po filtrovani */
    filterEmpty,
    /** Datagrid je prázdný po fulltextovem vyhledávání */
    fulltextEmpty,
    /** Datagrid je prázdný z důvodu nastavení QueryMode na formu */
    queryModeEmpty,
    /** Datagrid je prázdný, ale načítá data */
    dataLoading,
}
